<template lang="pug">
.text-center
  h4.max-w-300.mx-auto.mb-4 What
    span.text-success  causes
    |  does your organization tackle?

  .mb-4
    | At Spotlight, we call these bullhorns to serve as a daily reminder
    | that we all need to raise the volume up to empower change.

  hr

  el-checkbox-group(v-model="items").bnt-round
    el-checkbox-button(
      v-for="item in bullhorns.items"
      :label="item.id"
      :key="item.id"
    ) {{ item.bullhorn }}

  .text-center.py-4(v-if="isOnlyFavourite")
    el-button(round type="success" @click="showAllBullHorns(false)") Show All BullHorns
  .text-center.py-4(v-if="!isOnlyFavourite")
    el-button(round type="success" @click="showAllBullHorns(true)") Show Recommended

  hr

  .text-center.py-4
    el-button(round type="success" @click="submitForm") Next
</template>

<script lang="ts">

import {
  defineComponent,
  reactive,
  onMounted,
  ref,
} from 'vue';
import { useRouter } from 'vue-router';
import useOnboardingRoute from './composables/useOnboardingRoute';

export default defineComponent({
  name: 'Onboarding_Bullhorns',
  setup() {
    const {
      initData,
      commitAndGotoNextRoute,
      getBullhorns,
      canOnBoard,
    } = useOnboardingRoute('causes');
    const items = ref(initData);
    const bullhorns = reactive({ items: [] });
    const router = useRouter();
    const isOnlyFavourite = ref(true);

    onMounted(async () => {
      try {
        if (!canOnBoard()) {
          router.push('/');
        }
        const result = await getBullhorns(true);
        bullhorns.items = result;
      } catch (err) {
        console.log(err);
      }
    });

    async function showAllBullHorns(getfavourite: boolean) {
      const result = await getBullhorns(getfavourite);
      bullhorns.items = result;
      isOnlyFavourite.value = getfavourite;
    }

    return {
      // data (static)
      bullhorns,
      // data (dynamic)
      items,
      // methods
      submitForm: () => commitAndGotoNextRoute(items),
      showAllBullHorns,
      isOnlyFavourite,
    };
  },
});
</script>
